module.exports = __webpack_public_path__ + "static/media/je.50fcaf62.svg";